export const shouldShowAcEmailInputForm = ({
  isLoading,
  isProfileLoaded,
  acEmail,
  pendingAcEmail,
  isVerifiedByStudentCard,
}: {
  isLoading: boolean;
  isProfileLoaded: boolean;
  acEmail: string;
  pendingAcEmail: string;
  isVerifiedByStudentCard: boolean;
}): boolean =>
  !isLoading &&
  isProfileLoaded &&
  pendingAcEmail === '' &&
  acEmail === '' &&
  !isVerifiedByStudentCard;
